export default __webpack_public_path__ + "static/media/003-temple.027edb3a.svg";